/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentUpgradeStatusEnum } from './deploymentUpgradeStatusEnum';
import { VcdsComponentVersionHistory } from './vcdsComponentVersionHistory';


export interface VcdsComponentVersion { 
    /**
     * Current deployment version
     */
    current_version?: string;
    upgrade_eligible?: DeploymentUpgradeStatusEnum;
    /**
     * Release Type
     */
    release_type?: string;
    /**
     * Release Type
     */
    upgradable_version?: string;
    /**
     * Is upgrade in progress
     */
    upgrade_in_progress?: boolean;
    history?: Array<VcdsComponentVersionHistory>;
}
export namespace VcdsComponentVersion {
}


